import materialOverrides from '@styles/material-overrides'
import '@styles/keyframes.css'
import '@styles/global.css'
import { WindowVisibilityProvider } from '@contexts/windowVisibilityContext'
import { AgeVerificationProvider } from '@contexts/ageVerificationContext'
import { CurrentLocationProvider } from '@contexts/currentLocationContext'
import { ScrollTriggerProvider } from '@contexts/scrollTriggerContext'
import { PaymentsApiProvider } from '@contexts/paymentsApiContext'
import { ConnectionProvider } from '@contexts/connectionContext'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { AuthProvider } from '@contexts/authContext'
import { ThemeProvider} from '@mui/material'

const Providers = ({ children }) => (
  <AgeVerificationProvider>
    <AuthProvider>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}>
        <ConnectionProvider>
          <WindowVisibilityProvider>
            <ThemeProvider theme={materialOverrides}>
              <CurrentLocationProvider>
                <PaymentsApiProvider>
                  <ScrollTriggerProvider>
                    {children}
                  </ScrollTriggerProvider>
                </PaymentsApiProvider>
              </CurrentLocationProvider>
            </ThemeProvider>
          </WindowVisibilityProvider>
        </ConnectionProvider>
      </GoogleOAuthProvider>
    </AuthProvider>
  </AgeVerificationProvider>
)


export default Providers